import { render } from "./MyWork.vue?vue&type=template&id=7d21c4fd&scoped=true"
import script from "./MyWork.vue?vue&type=script&lang=js"
export * from "./MyWork.vue?vue&type=script&lang=js"

import "./MyWork.vue?vue&type=style&index=0&id=7d21c4fd&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d21c4fd"]])

export default __exports__